<template>
  <div class="history-table">
    <div v-for="item in historyData" :key="item.id" class="history-table__row">
      <div class="history-table__type">
        <div class="history-table__icon">
          <IconRound :icon="item.type" />
        </div>
        <div class="history-table__name">
          <div class="history-table__name-title">
            {{ item.name }}
          </div>
          <div class="history-table__name-desc">
            {{ item.desc }}
          </div>
        </div>
      </div>
      <div class="history-table__info">
        <div class="history-table__amounts">
          <div
            class="history-table__amounts-total"
            :class="'history-table__amounts-total--' + item.type"
          >
            {{
              locale === 'RU'
                ? numberWithSpaces(item.amountTotal).split('.')[0] +
                  ' ' +
                  $t('currency.currency_symbol')
                : numberWithSpacesFix2(item.amountTotal) + $t('currency.currency_symbol')
            }}
          </div>
        </div>
        <div class="history-table__date">
          <!-- {{ fixDateFormatTime(item.date) }} -->
          {{ fixDateFormatLocale(item.date) }}
        </div>
        <div v-if="isAdmin" class="history-table__actions">
          <button
            class="history-table__delete-btn"
            :title="$t('transaction.delete')"
            @click="handleDeleteClick(item.id)"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4V13.3333C12 13.687 11.8595 14.0261 11.6095 14.2761C11.3594 14.5262 11.0203 14.6667 10.6667 14.6667H5.33333C4.97971 14.6667 4.64057 14.5262 4.39052 14.2761C4.14048 14.0261 4 13.687 4 13.3333V4H12Z"
                stroke="#EB5757"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.66667 4V2.66667C6.66667 2.31305 6.80714 1.97391 7.05719 1.72386C7.30724 1.47381 7.64638 1.33334 8 1.33334H8.66667C9.02029 1.33334 9.35943 1.47381 9.60948 1.72386C9.85952 1.97391 10 2.31305 10 2.66667V4"
                stroke="#EB5757"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2 4H14"
                stroke="#EB5757"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.66667 7.33334V11.3333"
                stroke="#EB5757"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.33333 7.33334V11.3333"
                stroke="#EB5757"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div v-if="historyData && !historyData.length">
      {{ $t('nothing_found') }}
    </div>
  </div>
</template>

<script>
import IconRound from '@/components/elements/IconRound';
import fixDateFormatTime from '@/mixin/fixDate';
import fixDateFormatLocale from '@/mixin/fixDate';
import numberWithSpaces from '@/mixin/numberWithSpaces';
import numberWithSpacesFix2 from '@/mixin/numberWithSpaces';

export default {
  name: 'HistoryTable',
  components: {
    IconRound,
  },
  mixins: [fixDateFormatTime, numberWithSpaces, numberWithSpacesFix2, fixDateFormatLocale],
  data() {
    return {
      locale: process.env.VUE_APP_LOCALE,
    };
  },
  computed: {
    historyData() {
      return this.$store.state.Ad.history;
    },
    isAdmin() {
      return this.$store.state.Auth.role === 'admin';
    },
  },
  mounted() {},
  methods: {
    getNewPage(page) {
      const query = { ...this.$route.query, page };
      this.$router.push({ query });
    },
    handleDeleteClick(transactionId) {
      this.$store.commit('Dialog/setData', {
        label: 'activeDialog',
        data: 'DeleteTransactionConfirm',
      });
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true });
      this.$store.commit('Dialog/setData', { label: 'transactionToDelete', data: transactionId });
    },
    refreshHistory() {
      const query = { ...this.$route.query };
      const params = {
        ...query,
        ...(query.type_id && { types: query.type_id.split(',') }),
      };

      const data = {
        id: this.$store.state.Auth.activeAccount.id,
        params: params,
      };

      this.$store.dispatch('Ad/getHistory', data);
    },
  },
  created() {
    // Слушаем событие удаления транзакции для обновления списка
    this.$root.$on('transaction-deleted', this.refreshHistory);
  },
  beforeDestroy() {
    this.$root.$off('transaction-deleted', this.refreshHistory);
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/helpers/variables';
@import '../../assets/styles/helpers/mixin';

.history-table {
  &__row {
    display: flex;
    justify-content: space-between;
    background-color: $basicWhite;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    padding: 1.5rem 1rem 1.5rem 2rem;
  }

  &__type {
    display: flex;
    align-items: center;
  }

  &__icon {
    margin-right: 1.2rem;
  }

  &__name {
    padding-right: 2rem;

    &-title {
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: $basicBlack;
      margin-bottom: 0.5rem;
    }

    &-desc {
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: $gray2;

      &::first-letter {
        text-transform: uppercase;
      }
    }
  }

  &__info {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  &__actions {
    display: flex;
    align-items: center;
    margin-left: 1rem;
  }

  &__delete-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }

    &:active {
      transform: scale(0.95);
    }

    svg {
      display: block;
    }
  }

  &__amounts {
    margin-right: 3rem;

    &-total {
      white-space: nowrap;
      font-size: 1.6rem;
      line-height: 1.9rem;
      text-align: right;
      color: $greenClassic;
      margin-bottom: 0.5rem;

      &--out,
      &--fine,
      &--ad,
      &--add-custom {
        color: $basicBlack;
      }

      &--cashback {
        color: $primary;
      }
    }

    &-usd {
      font-size: 1.6rem;
      line-height: 1.9rem;
      color: $gray2;
      text-align: right;
    }
  }

  &__date {
    width: 12rem;
    white-space: nowrap;
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: $gray2;
  }

  @include below(769px) {
    &__row {
      flex-direction: column;
      padding: 8px 16px;
    }

    &__type {
      width: 100%;
      align-items: flex-start;
      margin-bottom: 8px;
    }

    &__icon {
      margin-right: 8px;

      .icon {
        width: 32px;
        height: 32px;
      }
    }

    &__name {
      padding-right: 0;

      &-title {
        font-size: 14px;
        line-height: 1.4;
        margin-bottom: 4px;
      }

      &-desc {
        font-size: 12px;
        line-height: 1.4;
      }
    }

    &__info {
      width: 100%;
      padding-left: 40px;
      align-items: center;
      justify-content: space-between;
      margin-left: auto;
    }

    &__actions {
      margin-left: 0;
      margin-top: 0.5rem;
    }

    &__delete-btn {
      padding: 0.3rem;
    }

    &__amounts {
      margin-right: 16px;

      &-total {
        margin-bottom: 0;
        font-size: 14px;
        line-height: 1.4;
      }
    }

    &__date {
      width: auto;
      font-size: 14px;
      line-height: 1.4;
    }
  }
}
</style>
